export const logging_config = {
    "logLevels": [
        {
        "loggerName": "root",
        "logLevel": "INFO"
        }
    ],
    "localStorageAppender": {
        "localStorageKey": "deviceLogs",
        "maxMessages": 2000,
        "threshold": "INFO"
    },
    "browserConsoleAppender": {
        "threshold": "OFF"
        // "threshold": "DEBUG"
    }
}